<template lang="pug">
f7-page#students
  navbar(title="生徒一覧")

  background
    .students
      student-list
</template>

<style lang="scss" scoped>
.icon-curriculum {
  width: 25px;
}

.students {
  padding-top: 8px;
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'
import StudentList from '@/components/organisms/StudentList'

export default {
  components: {
    StudentList,
  },
  mixins: [PageTitle],
  title: '生徒一覧',
}
</script>
